<template>
  <closable-list-item
    :is-visible="hasQueues && !isHiddenQueueServicesNotification"
    path-name="callQueues"
    @close="hideQueueServicesNotification"
  >
    <template #content>
      <div class="shrink-0 bg-blue-208-80-86 rounded-full h-12 w-12 flex items-center justify-center text-black">
        <wui-icon
          name="phoneM"
          large
        />
      </div>
      <span class="text-1316 text-wrap max-w-[264px]">
        {{ $t('common.queueServicesDescription') }}
      </span>
    </template>
  </closable-list-item>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'

import {
  hideQueueServicesNotification,
  isHiddenQueueServicesNotification,
  useQueueServiceStore,
} from '@/entities/queue-service'

import { ClosableListItem } from '@/shared/components/closable-list-item'

const { hasQueues } = storeToRefs(useQueueServiceStore())
</script>
